module.exports = __webpack_public_path__ + "img/nuvola_2.3b8ad0c4.png";